import { useEffect, useRef, useState } from 'react';
import { TAGLINE_LINES } from './landingContent';
import { usePrefersReducedMotion } from './useLandingReveal';

/**
 * Mandatory two-line tagline. Words start at 30% opacity and transition
 * to full text color in reading order when the section crosses the
 * trigger line. Reduced motion renders everything at full opacity.
 */
function TaglineReveal() {
  const reducedMotion = usePrefersReducedMotion();
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (reducedMotion) {
      setActive(true);
      return undefined;
    }
    const el = sectionRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [reducedMotion]);

  const words = TAGLINE_LINES.flatMap((line) => line.split(' '));
  let wordIndex = 0;

  return (
    <section
      ref={sectionRef}
      className={`lp-tagline${active ? ' lp-tagline--visible' : ''}`}
      aria-label={TAGLINE_LINES.join(' ')}
    >
      <div className="lp-container">
        <p className="lp-tagline__text" aria-hidden="true">
          {TAGLINE_LINES.map((line) => (
            <span className="lp-tagline__line" key={line}>
              {line.split(' ').map((word) => {
                wordIndex += 1;
                const delay = (wordIndex - 1) * 70;
                return (
                  <span key={`${line}-${wordIndex}`}>
                    <span
                      className="lp-tagline__word"
                      style={reducedMotion ? undefined : { transitionDelay: `${delay}ms` }}
                    >
                      {word}
                    </span>
                    {wordIndex < words.length ? ' ' : null}
                  </span>
                );
              })}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
}

export default TaglineReveal;
